import React from "react";
import { cn } from "../../lib/utils";

export const Input = React.forwardRef(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={cn(
      "w-full rounded-sm border border-ink-300 bg-white px-3 py-2.5 text-sm text-ink-900 placeholder:text-warm-400 transition-crisp focus:border-brand-400 focus:outline-none focus-visible:ring-1 focus-visible:ring-brand-400 disabled:bg-ink-100",
      className
    )}
    {...props}
  />
));
Input.displayName = "Input";

export const Label = ({ className, children, ...props }) => (
  <label
    className={cn(
      "text-xs uppercase tracking-widest font-semibold text-warm-600 mb-2 block",
      className
    )}
    {...props}
  >
    {children}
  </label>
);
